module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s007"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Overnight Eggs Benedict")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/17-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: Serves 6 to 8 | Prep Time: 20 minutes plus overnight set | Cook Time: 1 hour")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("I thought eggs Benedict was a restaurant-only food, too challenging to replicate at home. But my, was I wrong! And the real kicker? This version is made the night before, so you don’t have to do any work in the morning. With sliced ham and English muffins baked in eggs and topped with a simple hollandaise, this may not look like the eggs Benedict you’re familiar with, but its taste rivals some of the best.")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indger1"
  }, [_vm._v("6 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup half-and-half")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("3 scallions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 (7-ounce) ham steaks, cut into ½-inch dice")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("6 English muffins, toasted and cut into 1-inch cubes")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 (.9-ounce) package hollandaise sauce mix")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("4 tablespoons unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("Fresh parsley, for garnish")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Lightly coat a 9 × 13-inch baking dish with cooking spray. Whisk together the eggs, half-and-half, scallions, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. Spread half of the ham in the baking dish. Place the toasted English muffin cubes on top of the ham and then top with the remaining ham. Pour the egg mixture over the casserole, cover, and refrigerate overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("3. Heat the oven to 375°F. Sprinkle the paprika over the casserole, cover with foil, and bake for 45 minutes. Remove the foil and bake until the egg mixture is set, an additional 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("4. Meanwhile, whisk the milk and hollandaise sauce mix together in a saucepan. Add the butter and bring to a boil, stirring. Lower the heat to a simmer and stir until thick. Drizzle the sauce over the casserole and serve, garnished with parsley sprigs.")]), _vm._v(" "), _c('h2', {
    staticClass: "head"
  }, [_c('strong', [_vm._v("VARIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Use whole-wheat English muffins for a healthier alternative.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bc7086c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s007.vue
// module id = 102
// module chunks = 0